import {
    Action,
    ActionButton,
    EMPTY_TRANSLATION_TABLE,
    OpenCharacterCreatorAction,
    OpenCharacterExpressionAction,
    OpenDistrictAction,
    OpenInStoreAction,
    OpenLocationAction,
    OpenOutfitDesignerAction,
    OpenPortalAction,
    OpenShopAction,
    UnityColor,
} from '@lifeserver/shared';

export type {
    Action,
    ActionButton,
    OpenCharacterCreatorAction,
    OpenCharacterExpressionAction,
    OpenDistrictAction,
    OpenInStoreAction,
    OpenLocationAction,
    OpenOutfitDesignerAction,
    OpenPortalAction,
    OpenShopAction,
} from '@lifeserver/shared';
export { isButtonType } from '@lifeserver/shared';

export const DEFAULT_OPEN_PORTAL_ACTION: OpenPortalAction = {
    $type: 'OpenPortal',
};
export const DEFAULT_OPEN_SHOP_ACTION: OpenShopAction = {
    $type: 'OpenShop',
    packId: '',
};
export const DEFAULT_OPEN_LOCATION_ACTION: OpenLocationAction = {
    $type: 'OpenLocation',
    locationName: '',
};
export const DEFAULT_OPEN_DISTRICT_ACTION: OpenDistrictAction = {
    $type: 'OpenDistrict',
    districtName: '',
};
export const DEFAULT_OPEN_CHARACTER_CREATOR_ACTION: OpenCharacterCreatorAction =
    {
        $type: 'OpenCharacterCreator',
    };
export const DEFAULT_OPEN_OUTFIT_DESIGNER_ACTION: OpenOutfitDesignerAction = {
    $type: 'OpenOutfitDesigner',
};
export const DEFAULT_OPEN_CHARACTER_EXPRESSION_ACTION: OpenCharacterExpressionAction =
    {
        $type: 'OpenCEX',
    };
export const DEFAULT_OPEN_IN_STORE_ACTION: OpenInStoreAction = {
    $type: 'OpenInStore',
};

const getDefaultButtonColor = (action: Action): UnityColor => {
    switch (action.$type) {
        case 'OpenShop':
            return { r: 0.11, g: 0.651, b: 0.184, a: 1 };
        case 'OpenInStore':
            return { r: 0.317, g: 0.467, b: 0.811, a: 1 };
        default:
            return { r: 1, g: 0.612, b: 0.192, a: 1 };
    }
};

export const getDefaultButton = <A extends Action>(
    action: A,
): ActionButton & { action: A } => {
    return {
        textColor: { r: 1, g: 1, b: 1, a: 1 },
        backgroundColor: getDefaultButtonColor(action),
        text: EMPTY_TRANSLATION_TABLE,
        action,
    };
};
